import { Component, OnInit, ViewEncapsulation, Input } from '@angular/core';

@Component({
	selector      : 'app-home-banner',
	templateUrl   : './home-banner.component.html',
	encapsulation : ViewEncapsulation.None,
})

export class HomeBannerComponent implements OnInit {
	@Input() homeBannerSectionClass : any;
	@Input() homeBannerImage        : any;
	@Input() homeBannerContent : any;
	public isMobile : boolean;
	
	constructor() {
		if ( devicePixelRatio > 1.5 && document.body.clientWidth < 767 )
            this.isMobile = true;
        else
            this.isMobile = false;
	}

	ngOnInit(): void {}

	ngAfterViewInit() {
		let scripts = document.querySelector('script[id="scripted_iframe_video"]');
		if ( scripts ) {
			var script  = document.createElement( 'script' );
			script.src  = scripts.getAttribute( 'src' );
			document.body.appendChild( script );
		}
	}
}